<div class="ultimiStepWrapper">
  <div class="loading" [ngClass]="{ attivo: getAttivo() }"></div>
  <mat-accordion class="ultimiStep">
    <mat-expansion-panel
      [expanded]="step === 0"
      (opened)="setStep(0)"
      hideToggle
      [disabled]="step === 4"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "base.controlla_carrello" | translate }}
        </mat-panel-title>
        <mat-icon *ngIf="step == 0">shopping_cart</mat-icon>
        <mat-icon *ngIf="step > 0" class="text-verde">check_circle</mat-icon>
      </mat-expansion-panel-header>
      <div>
        <div *ngIf="canInsertCodiciScontoCarrello()">
          <div class="row justify-content-end">
            <div class="col-12 col-md-6">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>
                  {{ "carrello_sconto.input_label" | translate }}
                </mat-label>
                <input
                  matInput
                  placeholder="{{
                    'carrello_sconto.input_placeholder' | translate
                  }}"
                  [(ngModel)]="codiceScontoCarrello"
                  (keydown.enter)="controllaCodiceScontoCarrello()"
                />
                <button
                  matSuffix
                  mat-icon-button
                  (click)="controllaCodiceScontoCarrello()"
                  *ngIf="codiceScontoCarrello && codiceScontoCarrello !== ''"
                >
                  <mat-icon *ngIf="!loadingCodici"> add_box </mat-icon>
                  <mat-icon class="rotate" *ngIf="loadingCodici">
                    autorenew
                  </mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </div>
        <app-carrello-items
          [carrello]="carrelloVisite"
          [buoniCantina]="carrelloBuoniCantina"
          [listaCodiciScontoCarrello]="listaCodiciScontoCarrello"
          [carrelloPacchetti]="carrelloPacchetti"
          [carrelloVini]="carrelloVini"
          [formCarrello]="formCarrello"
          [controllaCantinaSC]="controllaCantinaSC()"
          (rimuoviDalCarrelloBuoniCantinaEmit)="
            rimuoviDalCarrelloBuoniCantina($event)
          "
          (rimuoviDalCarrelloEmit)="rimuoviDalCarrello($event)"
          (rimuoviDalCarrelloSCEmit)="rimuoviDalCarrelloSC($event)"
          (rimuoviDalCarrelloViniEmit)="rimuoviDalCarrelloVini($event)"
          (rimuoviDalCarrelloPacchettiEmit)="
            rimuoviDalCarrelloPacchetti($event)
          "
          (rimuoviDalCarrelloVinoSingoloEmit)="
            rimuoviDalCarrelloVinoSingolo($event)
          "
          (rimuoviCodiceScontoVinoEmit)="rimuoviCodiceScontoVino($event)"
          *ngIf="!loadingCarrello"
        >
        </app-carrello-items>
        <app-caricamento *ngIf="loadingCarrello"></app-caricamento>
        <mat-action-row>
          <button
            class="step__btn"
            (click)="nextStep()"
            *ngIf="pezziMinViniOk() && isMultipliVinoOK() && carrelloPieno()"
          >
            {{ "generale.continua" | translate }}
          </button>
          <button
            class="step__btn"
            (click)="chiudiBooking()"
            *ngIf="!pezziMinViniOk() || !isMultipliVinoOK()"
          >
            {{ "base.torna_vini" | translate }}
          </button>
        </mat-action-row>
      </div>
    </mat-expansion-panel>

    <!-- DATI PERSONALI-->
    <mat-expansion-panel
      [expanded]="step === 1"
      (opened)="setStep(1)"
      hideToggle
      [disabled]="
        !carrelloPieno() ||
        !pezziMinViniOk() ||
        !isMultipliVinoOK() ||
        step === 4
      "
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "base.dati_personali" | translate }}
        </mat-panel-title>
        <mat-icon *ngIf="!formCarrello.valid">account_circle</mat-icon>
        <mat-icon *ngIf="formCarrello.valid" class="text-verde"
          >check_circle</mat-icon
        >
      </mat-expansion-panel-header>

      <div>
        <p class="mt-1">
          {{ "base.dati_personali_necessarie" | translate }}
        </p>
        <div id="formcarrello">
          <div [formGroup]="formCarrello">
            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>{{ "registrazione.nome" | translate }}</mat-label>
                <input
                  matInput
                  placeholder="{{ 'registrazione.nome' | translate }}"
                  formControlName="nome"
                />
                <mat-error *ngIf="nomeFormControl.hasError('required')">
                  {{ "generale.richiesto" | translate }}
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ "registrazione.cognome" | translate }}</mat-label>
                <input
                  matInput
                  placeholder="{{ 'registrazione.cognome' | translate }}"
                  formControlName="cognome"
                />
                <mat-error *ngIf="cognomeFormControl.hasError('required')">
                  {{ "generale.richiesto" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>{{ "registrazione.nazione" | translate }}</mat-label>
                <mat-select
                  placeholder="{{ 'registrazione.nazione' | translate }}"
                  formControlName="nazione"
                  (selectionChange)="cambiaNazione()"
                >
                  <mat-option
                    *ngFor="let stato of statiSelect2Data"
                    [value]="stato.id"
                  >
                    {{ stato.text }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="nazioneFormControl.hasError('required')">
                  {{ "generale.richiesto" | translate }}
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ "registrazione.cap" | translate }}</mat-label>
                <input
                  matInput
                  placeholder="{{ 'registrazione.cap' | translate }}"
                  [formControl]="capFormControl"
                />
                <mat-error *ngIf="capFormControl.hasError('required')">
                  {{ "generale.richiesto" | translate }}
                </mat-error>
                <mat-error *ngIf="capFormControl.hasError('pattern')">
                  {{ "generale.formatoerrato" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>{{
                  "registrazione.telefono" | translate
                }}</mat-label>
                <input
                  matInput
                  placeholder="{{ 'registrazione.telefono' | translate }}"
                  [formControl]="telefonoFormControl"
                />
                <mat-error *ngIf="telefonoFormControl.hasError('required')">
                  {{ "generale.richiesto" | translate }}
                </mat-error>
                <mat-error *ngIf="telefonoFormControl.hasError('pattern')">
                  {{ "generale.formatoerrato" | translate }}
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ "registrazione.email" | translate }}</mat-label>
                <input
                  matInput
                  placeholder="{{ 'registrazione.email' | translate }}"
                  [formControl]="emailFormControl"
                />
                <!-- <mat-hint>{{'step1.emailinfo' | translate}}</mat-hint> -->
                <mat-error
                  *ngIf="
                    emailFormControl.hasError('email') &&
                    !emailFormControl.hasError('required')
                  "
                >
                  {{ "generale.emailvalida" | translate }}
                </mat-error>
                <mat-error *ngIf="emailFormControl.hasError('required')">
                  {{ "generale.richiesto" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div [formGroup]="formCarrello">
            <div class="row">
              <mat-form-field class="grow" appearance="outline">
                <mat-label>{{ "registrazione.note" | translate }}</mat-label>
                <textarea
                  matInput
                  placeholder="{{ 'registrazione.note' | translate }}"
                  [formControl]="noteOrdineFormControl"
                ></textarea>
              </mat-form-field>
            </div>

            <div
              fxLayout="column"
              fxLayoutAlign="start start"
              fxFill
              class="mt-20 mb-20"
            >
              <p>{{ "registrazione.docinfo" | translate }}</p>
              <mat-radio-group
                [formControl]="tipoDocFormControl"
                (change)="tipoDocChange($event)"
                fxLayout="row"
                fxLayoutAlign="start start"
                fxLayoutGap="20px"
              >
                <mat-radio-button value="R">{{
                  "registrazione.ricevuta" | translate
                }}</mat-radio-button>
                <mat-radio-button value="F">{{
                  "registrazione.fattura" | translate
                }}</mat-radio-button>
              </mat-radio-group>
            </div>

            <p>
              <span class="corsivo">{{
                "registrazione.notedoc" | translate
              }}</span>
            </p>

            <div *ngIf="tipoDocFormControl.value == 'F'">
              <div class="row">
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "registrazione.denominazione" | translate
                  }}</mat-label>
                  <input
                    matInput
                    placeholder="{{
                      'registrazione.denominazione' | translate
                    }}"
                    [formControl]="fDenominazioneFormControl"
                  />
                  <mat-error
                    *ngIf="fDenominazioneFormControl.hasError('required')"
                  >
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="row">
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "registrazione.indirizzo" | translate
                  }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'registrazione.indirizzo' | translate }}"
                    [formControl]="fIndirizzoFormControl"
                  />
                  <mat-error *ngIf="fIndirizzoFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{ "registrazione.cap" | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'registrazione.cap' | translate }}"
                    [formControl]="fCapFormControl"
                  />
                  <mat-error *ngIf="fCapFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="row">
                <mat-form-field appearance="outline">
                  <mat-label>{{ "registrazione.citta" | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'registrazione.citta' | translate }}"
                    [formControl]="fCittaFormControl"
                  />
                  <mat-error *ngIf="fCittaFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>
                    {{ "registrazione.provincia" | translate }}
                  </mat-label>

                  <mat-select
                    autoActiveFirstOption
                    [formControl]="fProvinciaFormControl"
                  >
                    <mat-option
                      *ngFor="let provincia of provincie"
                      [value]="provincia.sigla"
                    >
                      {{ provincia.provincia }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      fProvinciaFormControl.hasError('required') &&
                      (fProvinciaFormControl.dirty ||
                        fProvinciaFormControl.touched)
                    "
                  >
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="row">
                <mat-form-field appearance="outline">
                  <mat-label>{{ "registrazione.piva" | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'registrazione.piva' | translate }}"
                    [formControl]="fPivaFormControl"
                  />
                  <mat-error *ngIf="fPivaFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field appearance="outline">
                  <mat-label>{{ "registrazione.fe" | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'registrazione.fe' | translate }}"
                    [formControl]="fFeFormControl"
                  />
                  <mat-hint>{{ "registrazione.feInfo" | translate }}</mat-hint>
                  <mat-error *ngIf="fFeFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div
              *ngIf="
                tipoDocFormControl.value == 'R' &&
                controllaRichiediDatiFiscaliRicevuta()
              "
            >
              <div class="row">
                <mat-form-field appearance="outline">
                  <mat-label>{{ "registrazione.nome" | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'registrazione.nome' | translate }}"
                    [formControl]="rNomeFormControl"
                  />
                  <mat-error *ngIf="rNomeFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "registrazione.cognome" | translate
                  }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'registrazione.cognome' | translate }}"
                    [formControl]="rCognomeFormControl"
                  />
                  <mat-error *ngIf="rCognomeFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="row">
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "registrazione.indirizzo" | translate
                  }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'registrazione.indirizzo' | translate }}"
                    [formControl]="rIndirizzoFormControl"
                  />
                  <mat-error *ngIf="rIndirizzoFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{ "registrazione.cap" | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'registrazione.cap' | translate }}"
                    [formControl]="rCapFormControl"
                  />
                  <mat-error *ngIf="rCapFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="row">
                <mat-form-field appearance="outline">
                  <mat-label>{{ "registrazione.citta" | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'registrazione.citta' | translate }}"
                    [formControl]="rCittaFormControl"
                  />
                  <mat-error *ngIf="rCittaFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "registrazione.provincia" | translate
                  }}</mat-label>
                  <mat-select
                    autoActiveFirstOption
                    [formControl]="rProvinciaFormControl"
                  >
                    <mat-option
                      *ngFor="let provincia of provincie"
                      [value]="provincia.sigla"
                    >
                      {{ provincia.provincia }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="rProvinciaFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="row">
                <mat-form-field appearance="outline">
                  <mat-label>{{ "registrazione.cf" | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'registrazione.cf' | translate }}"
                    [formControl]="rCfFormControl"
                  />
                  <mat-error *ngIf="rCfFormControl.hasError('required')">
                    {{ "generale.richiesto" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="bloccoPrivacy">
              <div>
                {{ "registrazione.letto" | translate }}
                <a
                  target="_blank"
                  [href]="getLinkPrivacy()"
                  class="privacyLink"
                  rel="noopener noreferrer"
                  >{{ "registrazione.informativa" | translate }}</a
                >
                {{ "registrazione.ele" | translate }}
                <a
                  target="_blank"
                  [href]="getLinkCondizioni()"
                  class="privacyLink"
                  rel="noopener noreferrer"
                  >{{ "registrazione.condizioni" | translate }}</a
                >
              </div>

              <div class="privacyrule">
                <p class="corsivo mb-1">
                  {{ "registrazione.p1" | translate }}
                </p>
                <div class="">
                  <mat-radio-group [formControl]="p1FormControl">
                    <mat-radio-button class="mr-20 smallRadio" value="Y">
                      {{ "registrazione.acconsento" | translate }}
                    </mat-radio-button>
                    <mat-radio-button value="N" class="smallRadio">
                      {{ "registrazione.nonacconsento" | translate }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>

                <div
                  class="text-red piccolo"
                  *ngIf="
                    !p1FormControl.valid &&
                    p1FormControl.touched &&
                    p1FormControl.hasError('required')
                  "
                >
                  {{ "generale.richiesto" | translate }}
                </div>
                <div
                  class="text-red piccolo"
                  *ngIf="
                    !p1FormControl.valid &&
                    p1FormControl.touched &&
                    p1FormControl.hasError('pattern')
                  "
                >
                  {{ "registrazione.p1obbligo" | translate }}
                </div>
              </div>

              <div class="privacyrule">
                <p class="corsivo mb-1">
                  {{ "registrazione.p2" | translate }}
                </p>
                <div class="">
                  <mat-radio-group [formControl]="p2FormControl">
                    <mat-radio-button class="mr-20 smallRadio" value="Y">
                      {{ "registrazione.acconsento" | translate }}
                    </mat-radio-button>
                    <mat-radio-button value="N" class="smallRadio">
                      {{ "registrazione.nonacconsento" | translate }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                <div
                  class="text-red piccolo"
                  *ngIf="!p2FormControl.valid && p2FormControl.touched"
                >
                  {{ "generale.richiesto" | translate }}
                </div>
              </div>

              <div class="privacyrule">
                <p class="corsivo mb-1">
                  {{ "registrazione.p3" | translate }}
                </p>
                <div class="">
                  <mat-radio-group [formControl]="p3FormControl">
                    <mat-radio-button class="mr-20 smallRadio" value="Y">
                      {{ "registrazione.acconsento" | translate }}
                    </mat-radio-button>
                    <mat-radio-button value="N" class="smallRadio">
                      {{ "registrazione.nonacconsento" | translate }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                <div
                  class="text-red piccolo"
                  *ngIf="!p3FormControl.valid && p3FormControl.touched"
                >
                  {{ "generale.richiesto" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="isPresentWine()" class="mt-2">
          <div class="row mb-1" *ngIf="controllaWineshopSC()">
            <div class="col-6 d-flex justify-content-center">
              <div
                class="spedizione__scelta__box"
                [ngClass]="[
                  formCarrello.valid ? 'ok' : 'ko',
                  pagamentoWineshopSC && sceltaWineshopSC ? 'scelto' : ''
                ]"
                (click)="pagaWineshopSC(true)"
              >
                <span class="material-symbols-outlined"> local_shipping </span>
                <div class="spedizione__scelta__label">
                  {{ "carrello__item.cantina" | translate }}
                </div>
              </div>
            </div>
            <div class="col-6 d-flex justify-content-center">
              <div
                class="spedizione__scelta__box"
                [ngClass]="[
                  formCarrello.valid ? 'ok' : 'ko',
                  !pagamentoWineshopSC && sceltaWineshopSC ? 'scelto' : ''
                ]"
                (click)="pagaWineshopSC(false)"
              >
                <span class="material-symbols-outlined"> villa </span>
                <div class="spedizione__scelta__label">
                  {{ "carrello__item.casa" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!pagamentoWineshopSC">
            <div *ngIf="adm_spedizione_estero" class="mb-1">
              <div class="row justify-content-center mt-5">
                <div class="col-12 text-center mb-1">
                  <div class="spedizione__scelta__head">
                    {{ "carrello__item.selezionaspedizione" | translate }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="paese__box d-flex justify-content-center"
                  (click)="setPaeseSpedizione('IT')"
                >
                  <div
                    class="spedizione__scelta__box"
                    [ngClass]="paeseSpedizione === 'IT' ? 'scelto' : ''"
                  >
                    <span class="material-symbols-outlined">
                      local_shipping
                    </span>
                    <div class="spedizione__scelta__label">
                      {{ "carrello__item.spedizione_italia" | translate }}
                    </div>
                  </div>
                </div>
                <div
                  class="paese__box d-flex justify-content-center"
                  (click)="setPaeseSpedizione('WW')"
                >
                  <div
                    class="spedizione__scelta__box"
                    [ngClass]="paeseSpedizione === 'WW' ? 'scelto' : ''"
                  >
                    <span class="material-symbols-outlined">
                      local_shipping
                    </span>
                    <div class="spedizione__scelta__label">
                      {{ "carrello__item.spedizione_estero" | translate }}
                      <div class="spedizione__scelta__hint">
                        {{
                          "carrello__item.spedizione_estero__hint" | translate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="
                !pagamentoWineshopSC &&
                paeseSpedizione &&
                paeseSpedizione === 'IT'
              "
            ></div>

            <app-form-spedizione
              (formChanged)="setFormSpedizione($event)"
              [nome]="nome"
              [cognome]="cognome"
              [telefono]="telefono"
              [paeseSpedizione]="paeseSpedizione"
              *ngIf="
                !pagamentoWineshopSC &&
                ((paeseSpedizione && paeseSpedizione === 'IT') ||
                  (paeseSpedizione && paeseSpedizione === 'WW'))
              "
            ></app-form-spedizione>
          </div>
        </div>

        <mat-action-row>
          <button
            class="step__btn"
            (click)="gestisciAvanzamento()"
            [disabled]="!isFormsValid()"
          >
            {{ "generale.continua" | translate }}
            <span
              class="material-symbols-outlined rotate"
              *ngIf="loadingEstero"
            >
              refresh
            </span>
          </button>
        </mat-action-row>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="
        !checkPagamentoZero() &&
        ((paeseSpedizione && paeseSpedizione === 'IT') || !paeseSpedizione)
      "
      [expanded]="step === 2"
      (opened)="setStep(2)"
      [disabled]="
        step < 2 || !carrelloPieno() || !pezziMinViniOk() || !isMultipliVinoOK()
      "
      hideToggle
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "step2.pagamento" | translate }}
        </mat-panel-title>

        <mat-icon *ngIf="step < 2">payment</mat-icon>
        <mat-icon *ngIf="step >= 2" class="text-verde">check_circle</mat-icon>
      </mat-expansion-panel-header>
      <div>
        <div>
          <mat-radio-group [formControl]="tipoPagFormControl">
            <div class="pb-20" *ngIf="canPayCC() && !pagamentoWineshopSC">
              <mat-radio-button value="CC">
                <span class="wrap-mat-radio-label">{{
                  "step2.pagaCC" | translate
                }}</span>
              </mat-radio-button>
              <div class="bloccoInfoTipoPagamento">
                <div class="payment__wrapper">
                  <div
                    class="payment__item"
                    matTooltip="Visa"
                    matTooltipPosition="right"
                  >
                    <img
                      src="../../../assets/img/pagamenti/visa.jpg"
                      alt="Visa"
                      class="payment__img"
                    />
                  </div>
                  <div
                    class="payment__item"
                    matTooltip="Mastercard"
                    matTooltipPosition="right"
                  >
                    <img
                      src="../../../assets/img/pagamenti/mastercard.jpg"
                      alt="Mastercard"
                      class="payment__img"
                    />
                  </div>
                  <div
                    class="payment__item"
                    matTooltip="My bank"
                    matTooltipPosition="right"
                  >
                    <img
                      src="../../../assets/img/pagamenti/mybank.png"
                      alt="My bank"
                      class="payment__img"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="controllaCantina() && !isCodiceFormMasterPresente">
              <mat-radio-button value="CANTINA" class="test">
                <span class="wrap-mat-radio-label">
                  {{ "step2.pagaCantina" | translate }}
                </span>
              </mat-radio-button>
              <span
                class="bloccoInfoTipoPagamento corsivo mb-10"
                *ngIf="controllaCantina()"
              >
                {{ "step2.pagaCantinaNote" | translate }}
              </span>
              <span
                class="bloccoInfoTipoPagamento corsivo mb-10"
                *ngIf="controllaCantina()"
              >
                {{ "step2.pagaCantinaNoteDisabilitato" | translate }}
              </span>
            </div>

            <div
              *ngIf="
                controllaWineshopSC() &&
                !isCodiceFormMasterPresente &&
                pagamentoWineshopSC
              "
            >
              <mat-radio-button value="WINESHOPSC" class="test">
                <span class="wrap-mat-radio-label">
                  {{ "step2.pagaWineshopSC" | translate }}
                </span>
              </mat-radio-button>
            </div>

            <div *ngIf="controllaCantinaSC() && !isCodiceFormMasterPresente">
              <mat-radio-button value="CANTINASC" class="test">
                <span class="wrap-mat-radio-label">
                  {{ "step2.pagaCantina" | translate }}
                </span>
              </mat-radio-button>
              <div
                class="bloccoInfoTipoPagamento corsivo mb-10"
                *ngIf="carrelloHasSupplemento().has"
                [innerHTML]="
                  'step2.pagaCantinaNoteSC'
                    | translate : { supp: carrelloHasSupplemento().supp }
                "
              ></div>

              <hr />

              <div
                *ngFor="let riga of carrelloVisite; let last = last"
                class="bloccoInfoTipoPagamento"
              >
                <div
                  *ngIf="riga.checksupplemento === '1'"
                  [innerHTML]="
                    'base.detail_supplemento'
                      | translate
                        : {
                            value1: riga.tipovisita,
                            value2: riga.totale,
                            value3: getSupplementoRiga(riga) | number : '1.2-2',
                            value4:
                              getTotaleRigaConSupplemento(riga)
                              | number : '1.2-2'
                          }
                  "
                >
                  <br *ngIf="!last" /><br *ngIf="!last" />
                </div>
              </div>
            </div>

            <div class="sicurezza">
              <mat-icon class="icona-sicurezza">lock</mat-icon>
              {{ "base.sicurezza_pagamento" | translate }}
            </div>
          </mat-radio-group>
          <div
            class="col-12 col-sm-12 text-red piccolo"
            *ngIf="!tipoPagFormControl.valid && tipoPagFormControl.touched"
          >
            {{ "generale.richiesto" | translate }}
          </div>
        </div>
        <mat-action-row>
          <button
            class="step__btn"
            (click)="preparaDatiPerAcquisto()"
            [disabled]="!formTipoPagamento.valid"
          >
            {{ "generale.continua" | translate }}
          </button>
        </mat-action-row>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="step === 3"
      (opened)="setStep(3)"
      [disabled]="
        step !== 3 ||
        !carrelloPieno() ||
        !pezziMinViniOk() ||
        !isMultipliVinoOK()
      "
      hideToggle
      *ngIf="(paeseSpedizione && paeseSpedizione === 'IT') || !paeseSpedizione"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "step2.completa" | translate }}
        </mat-panel-title>
        <mat-icon>done_all</mat-icon>
      </mat-expansion-panel-header>

      <!-- <app-riepilogo-prenotazione [visita]="currentVisita" [carrello]="carrello" [cantinaSC]="isCantinaSC()"
                class="mb-20 d-block">
            </app-riepilogo-prenotazione> -->

      <div
        *ngIf="
          !checkPagamentoZero() &&
          !isCantinaSC() &&
          !isWineshopSC() &&
          codiceFormOk
        "
      >
        <p class="">{{ "step2.carta" | translate }}</p>
        <app-stripe
          #stripeComponent
          [locale]="lingua"
          [totale]="totale"
          [valori]="valori"
          [usaStripeCantina]="usaStripeCantina"
        ></app-stripe>
      </div>
      <div *ngIf="checkPagamentoZero() || isCantinaSC() || isWineshopSC()">
        <div *ngIf="!isCantinaSC() && !isWineshopSC()">
          <h3>{{ "step2.pagaZero" | translate }}</h3>
          <p>{{ "step2.pagaZeroNote" | translate }}</p>
        </div>
        <div *ngIf="isCantinaSC() && !isCodiceFormMasterPresente">
          <h3>{{ "step2.pagaZero" | translate }}</h3>
          <p>{{ "step2.pagaScNote" | translate }}</p>
        </div>
        <div *ngIf="isWineshopSC() && !isCodiceFormMasterPresente">
          <h3>{{ "step2.pagaZero" | translate }}</h3>
          <p>{{ "step2.pagaWineshopScNote" | translate }}</p>
        </div>
        <button (click)="completa()" class="btnPagaZero">
          {{ "step2.btnConferma" | translate }}
        </button>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="step === 4"
      [disabled]="step !== 4"
      *ngIf="paeseSpedizione && paeseSpedizione === 'WW'"
      hideToggle
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "step4.titolo" | translate }}
        </mat-panel-title>
        <mat-icon>local_shipping</mat-icon>
      </mat-expansion-panel-header>
      <div class="success" *ngIf="!erroreEstero && !loadingEstero">
        <span class="material-symbols-outlined icona ok"
          >check_circle_outline</span
        >
        <div class="title">
          {{ "step4.spedizione_estera_title_ok" | translate }}
        </div>
        <div
          class="message"
          [innerHTML]="'step4.spedizione_estera_content_ok' | translate"
        ></div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
